import { Link } from "react-router-dom";
import styles from "./Articles.module.scss";

export const Article1 = () => {
  return (
    <div className={styles.articles__wrapper}>
      <Link to={"/articles"}>&#8592; Назад к статьям</Link>
      <h5 className={styles.articles__header}>
        Программное обеспечение psycards
      </h5>
      <p className={styles.articles__pharagraph}>
        Психологическое консультирование на основе метафорических ассоциаций –
        популярная, пользующаяся большим спросом услуга. Традиционно данный вид
        услуг оказывался в процессе личного общения с клиентом, однако миграция
        в интернет происходила практически параллельно с его развитием. По
        крайней мере, объявления о гадании на картах таро, курсах и семинарах по
        развитию личности начали появляться в сети уже в начале двухтысячных.
      </p>
      <p className={styles.articles__pharagraph}>
        Переход в онлайн обеспечил стремительный рост данной сферы услуг,
        потребители получили боле широкий выбор, а консультанты значительно
        расширили базу клиентов.
      </p>
      <p className={styles.articles__pharagraph}>
        Программное обеспечение psycards – это специализированный инструмент для
        проведения психологического консультирования с возможностью проведения
        игр, основанных на психологических ассоциациях. Самым очевидным примером
        будут все те же расклады таро, но этим возможности программы далеко не
        исчерпываются.
      </p>
      <p className={styles.articles__pharagraph}>
        Программа адаптирована для интеграции с популярными платформами
        проведения видеоконференций, включая Zoom и Skype. Имеется собственная
        библиотека психологических игр, которая постоянно пополняется.
        Возможность проведения разных типов игр зависит от версии программы, но
        в любом случае подобный инструмент значительно расширяет возможности
        проведения психологических консультаций и тренингов.
      </p>
      <p className={styles.articles__pharagraph}>
        Psycards разрабатывалась при участии клинических психологов, тренеров и
        специалистов в области трансформационных игр.
      </p>
      <h5 className={styles.articles__header}>
        Возможности программного обеспечения psycards
      </h5>
      <p className={styles.articles__pharagraph}>
        Если <b>скачать psycards</b>, то можно:
        <ul className={styles.articles__ul}>
          <li>
            Организовывать сеансы гадания по картам таро и иным видам гадальных
            карты.
          </li>
          <li>
            Организовывать групповые сессии психологической консультации и
            семинары.
          </li>
          <li>Проводить коучинговые сессии.</li>
          <li>Интегрировать программу в работу с клиентами по zoom, skype.</li>
          <li>Устраивать интерактивные игры.</li>
        </ul>
      </p>
      <h5 className={styles.articles__header}>Преимущества psycards</h5>
      <p className={styles.articles__pharagraph}>
        Основной принцип работы разработчиков программного обеспечения psycards
        – это клиентоориентированность. Это выражается в наличии чёткой и ясной
        инструкции, а также иных обучающих материалов. Имеется квалифицированная
        техническая поддержка, ориентированная на индивидуальную работу с
        потребностями каждого клиента.
      </p>
      <p className={styles.articles__pharagraph}>
        Программа постоянно дополняется и улучшается, в том числе и благодаря
        отзывам пользователей, чьи пожелания всегда учитываются при выпуске
        новых версий. Пожалуй, продвинутая система обратной связи – ещё одно
        преимущество psycards.
      </p>
      <p className={styles.articles__pharagraph}>
        Заказы обрабатываются оперативно, с предоставлением чека, а для
        постоянных клиентов действует система скидок на продление лицензии и
        приобретение дополнительных игр.
      </p>
      <h5 className={styles.articles__header}>Версии программы</h5>
      <p className={styles.articles__pharagraph}>
        В настоящий момент на выбор предлагается две версии программы psycards:
        pro и lite. Если кратко, то для того, чтобы максимально использовать
        потенциал онлайн-консультирования, желательно приобрести{" "}
        <b>программное приложение psycards pro</b>.
      </p>
      <p className={styles.articles__pharagraph}>
        Pro версия предоставляет возможность загрузки собственных игровых
        наборов, не ограничена в плане проведения игр. Проведение консультация –
        это базовая возможность, которая одинакова доступна в обеих версиях.
      </p>
      <p className={styles.articles__pharagraph}>
        Lite версия также предоставляет доступ к организации
        онлайн-консультаций, но вот возможности проведения игр в этой версии
        несколько ограничены. Также невозможно загружать собственные наборы.
      </p>
      <p className={styles.articles__pharagraph}>
        <b>Скачать psycards</b> можно на сайте mak-online.ru, там же можно найти
        дополнительные материалы и контакты для консультации по поводу
        возможностей программы и приобретения лицензии.
      </p>
    </div>
  );
};
